export enum MessageSeverityEnum {
  success,
  default,
  info,
  error,
  warn,
  wait
}